import { Divider, Icon, Text, useColors } from "@certn/cascadia-react";
import { GhostIconButton } from "@certn/cascadia-react/components/button/GhostIconButton";
import { usePeopleAPI } from "@certn/legacy-api";
import { css } from "@emotion/css";
import { useState } from "react";
import { Trans } from "react-i18next";
import { useParams } from "react-router-dom";

import { SectionsList } from "./SectionsList";
import { useNavbar } from "./hooks";
import { useCheckFlowNavbarStyles } from "./styles";
import { useApplicationSections } from "../hooks";

type CheckFlowNavbarProps = {
  onClose: () => void;
};

export function CheckFlowNavbar({ onClose }: CheckFlowNavbarProps) {
  const colors = useColors();
  const styles = useCheckFlowNavbarStyles();
  const { canToggle } = useNavbar();
  const { data: sections } = useApplicationSections();
  const { applicantId } = useParams();
  const { data: applicant } = usePeopleAPI(
    `/internal/people/applicant/${applicantId}/`
  );
  const [isOverflown, setIsOverflown] = useState<boolean>();
  const [isScrolledToBottom, setIsScrolledToBottom] = useState<boolean>();

  if (!sections) return null;

  return (
    <div
      className={css(styles.container, {
        borderRight: `1px solid ${colors["border-base"]}`,
      })}
      data-testid="application-navigation-panel-container"
    >
      <div className={styles.header}>
        <div className={styles.title}>
          <Text style="summary/section-title">
            <Trans>BACKGROUND CHECK FOR</Trans>
          </Text>
          <Text
            style="summary/content-primary"
            testID="application-navigation-panel-team-name"
          >
            {applicant?.application?.team?.name ?? "-"}
          </Text>
        </div>

        {canToggle && (
          <GhostIconButton
            icon="close"
            size="medium"
            onPress={onClose}
            testID="application-navigation-panel-mobile-close-button"
          />
        )}
      </div>

      {(canToggle || isOverflown) && <Divider />}

      <SectionsList
        onClose={onClose}
        onOverflow={setIsOverflown}
        onScrollToBottom={setIsScrolledToBottom}
      />

      {isOverflown && !isScrolledToBottom && (
        <div
          className={css(styles.arrowIcon, {
            background: colors["background-accent-neutral-weak"],
          })}
        >
          <Icon name="arrow_downward" color="icon-weak" />
        </div>
      )}
    </div>
  );
}
